import {
  Divider,
  Unstable_Grid2 as Grid,
  IconButton,
  List,
  ListItem,
  Pagination,
  Tooltip,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  AddIcCall,
  Call,
  CallMade,
  CallReceived,
  ContentCopy,
} from '@mui/icons-material';
import { logger } from '../utilities/logger';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import duration from 'dayjs/plugin/duration';
import parsePhoneNumber from 'libphonenumber-js';
import { useTranscription } from '../providers/TranscriptionProvider';

export const TranscriptionError = () => {
  const { t } = useTranslation();
  return (
    <Grid
      container
      flexGrow={1}
      paddingLeft={1}
      paddingTop={2}
      paddingRight={1}
      paddingBottom={1}
      position={'relative'}
      height={'100%'}
      className='transcription-container'
    >
      <Typography>{t('transcription.errorBoundaryMessage')}</Typography>
    </Grid>
  );
};

export const Transcription = () => {
  dayjs.extend(localizedFormat);
  dayjs.extend(duration);
  const theme = useTheme();
  const log = logger();

  // Component Context
  const { t } = useTranslation();


  // Get Call Log from Local Storage at init
  useEffect(() => {
    const transcriptionString = localStorage.getItem('transcription');
    if (!transcriptionString) {
      return;
    }
  }, []);

  const TranscriptionTitle = () => {
    return (
      <>
        <Grid>
          <Grid container>
            <Typography variant='h4' color={theme.palette.info.main}>
              {t('transcription.pageTitle')}
            </Typography>
          </Grid>
        </Grid>
        <Grid>
          <Divider sx={{ margin: '1rem 0' }} />
        </Grid>
      </>
    );
  };

  const TranscriptionLog: React.FC = () => {
    const { messages } = useTranscription();

    return (
        <div>
            {messages.map((msg, index) => (
                <div key={index}>
                  <div><strong>{msg.origin}</strong></div>
                  <div>{msg.message}</div>
                </div> // Display each message on a new line
            ))}
        </div>
    );

  };
  return (
    <Grid
      container
      flexGrow={1}
      paddingLeft={1}
      paddingTop={2}
      paddingRight={1}
      paddingBottom={1}
      height={'100%'}
      className='transcription-main-container'
      flexDirection={'column'}
    >
      <TranscriptionTitle />
      <TranscriptionLog></TranscriptionLog>
      
    </Grid>
  );
};
